import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";
import { ChevronUpDownIcon, ArrowPathIcon } from "@heroicons/react/20/solid";
import { StarIcon } from "@heroicons/react/24/solid";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { useRef } from "react";
import TextInputBaseUnstyled from "../Inputs/TextInputBaseUnstyled";
import { TOption } from "./dropMenu.types";
interface ISearchSelectorProps {
  placeholder?: string;
  label?: string;
  value?: TOption | null;
  onChange: (value: TOption | null) => void;
  options: TOption[];
  error?: any;
  disabled?: boolean;
  className?: string;
  accessorKey?: string;
  textEllipsis?: number;
  query: string;
  redirectionPath?: string;
  isRequired?: boolean;
  setQuery: (value: string) => void;
  supportAnchor?: boolean;
  isLoading?: boolean;
}
export default function SearchSelectorUnstyled({
  className,
  label,
  options,
  error,
  value,
  accessorKey = "name",
  placeholder = "search ...",
  disabled = false,
  setQuery,
  onChange,
  textEllipsis = 70,
  isRequired = false,
  isLoading = false,
}: ISearchSelectorProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  // const navigate = useNavigate();

  return (
    <Combobox immediate value={value} onChange={onChange} disabled={disabled}>
      <div className="relative">
        <>
          <p className="text-xs font-semibold text-body">
            {" "}
            <label className="text-xs flex items-center gap-1 text-left text-body font-semibold pl-1">
              {label}
              {isRequired && (
                <StarIcon className="size-2 text-error -translate-y-1" />
              )}
            </label>
          </p>
          <ComboboxButton className="w-full">
            <ComboboxInput
              ref={inputRef}
              as={TextInputBaseUnstyled}
              icon={
                isLoading ? (
                  <ArrowPathIcon
                    className="h-5 w-5 text-gray animate-spin "
                    aria-hidden="true"
                  />
                ) : (
                  <ChevronUpDownIcon
                    className="h-5 w-5 text-gray "
                    aria-hidden="true"
                  />
                )
              }
              className={`h-10 w-full text-sm text-body font-semibold px-3 py-1 pl-3 pr-10 ${className} 
            placeholder:font-medium  ${
              error?.message
                ? "placeholder:text-error/70"
                : "placeholder:text-darkGray/80"
            }  z-10
            disabled:bg-gray-200 disabled:cursor-not-allowed  `}
              displayValue={(item: any) =>
                stringUtility.addEllipsisAtEnd(
                  item?.[accessorKey],
                  textEllipsis
                )
              }
              onChange={(event) => setQuery(event.target.value)}
              placeholder={placeholder}
            />
          </ComboboxButton>
        </>

        <ComboboxOptions
          transition
          className={`mt-2 max-h-48 absolute w-full shadow-md border bg-white 
         border-extraLightGray rounded-md overflow-y-auto outline-none z-50`}
        >
          {options?.length === 0 ? (
            <div className="flex flex-col gap-2 text-xs text-center font-semibold px-4 py-2 text-pretty">
              <p>No data available</p>
            </div>
          ) : (
            options?.map((item) => (
              <ComboboxOption
                key={item?.id}
                className="px-4 py-2 text-sm font-semibold transition-colors cursor-auto 
                select-none text-body outline-none data-[focus]:bg-primary/10"
                value={item}
              >
                {item?.[accessorKey]}
              </ComboboxOption>
            ))
          )}
        </ComboboxOptions>
      </div>
    </Combobox>
  );
}
